import React, { useState } from 'react';
import './choose-player-modal.styles.scss';
import Modal from '@/components/modal/modal.component';
import { completePlayerData, playerDocs } from '../previewPlayers';
import PlayerNameIcon from '@/components/PLAYER/player-blocks/components/status-elements/player-name-icon.component';
import { useNavigate } from 'react-router-dom';
import { setCurrentUser } from '@/state/slices/userSlice';
import { useDispatch } from 'react-redux';
import { RandomString } from '@/utils/randomString';

const ChoosePlayerModal = ({
  show,
  cancel
}) => {

  const [playerList, setPlayerList] = useState([
    {
      "path": "2uiwtc_w9wo88dhqj9",
      "desc": "Very Active Player"
    },
    {
      "path": "0cq39ufq8-sigmeb3y",
      "desc": "Moderately Active Player"
    },
    {
      "path": "s_zzkdwuk_iqor5b7d",
      "desc": "Inactive Player"
    }
  ]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function goToPlayerPreview(playerData) {
    localStorage.setItem('previewPlayerData', JSON.stringify({ playerId: playerData.playerId }));

    const currentUser = {
      "displayName": `${playerData.fName} ${playerData.lName}`,
      "email": `${RandomString(10)}@gamably.com`,
      "metadata": {
        "createdAt": new Date().getTime(),
      },
      "photoURL": "https://gamably.com/images/themes/2025/gamably_icon.png",
      "provider": "preview",
      "uid": "preview-player"
    }
    dispatch(setCurrentUser(currentUser));
    navigate('player/previewgame');
    cancel();
  }

  return (
    <div className='choose-player-modal'>
      <Modal
        show={show}
        cancel={cancel}
        closeButton={true}
        text="Choose a Player to Preview"
        cls="narrow" >
        <div className='player-list'>
          {
            (playerList && completePlayerData) &&
            playerList.map(playerPath => {
              const playerData = Object.values(completePlayerData).find(p => p.path === playerPath.path);
              return (
                <button
                  key={playerPath.path}
                  className='player-list-item g-button'
                  onClick={() => goToPlayerPreview(playerData)}>
                  <div className='player-icon'>
                    {/* < profile={playerData} /> */}
                    <PlayerNameIcon
                      player={playerData}
                      hideName={true} />
                  </div>
                  <div className='player-name'>
                    {
                      playerData
                        ? `${playerData.fName} ${playerData.lName}`
                        : 'Unknown Player'
                    }
                  </div>
                  <div className='player-desc meta'>
                    {playerPath.desc}
                  </div>
                </button>
              )
            })
          }
        </div>
      </Modal>
    </div>
  )
}

export default ChoosePlayerModal